<template>
  <section class="profile" data-test="OPEN_MODAL_CREATE_PROFILE" @click="handleClick">
    <PlusOutlined class="profile__icon" />

    <p class="profile__description">Crear nuevo perfil</p>
  </section>
</template>

<script>
import { PlusOutlined } from "@ant-design/icons-vue";

export default {
  components: {
    PlusOutlined,
  },
  name: "ProfileCardCreator",
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="sass" scoped>
.profile
  height: 210px
  background: $blue-1
  border-radius: 4px
  border: 1.5px dashed $primary
  cursor: pointer

  &__icon
    margin: 66px auto 8px
    display: block
    color: $primary
    font-size: 40px

  &__description
    font-size: $font-small
    text-align: center
    color: $primary
</style>
